import { useCallback, useEffect, useMemo, useState } from "react";
import "./SubscriptionPriceSectionComponent.scss";
import SubscriptionPriceCardComponent from "../SubscriptionPriceCard/SubscriptionPriceCardComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubscriptionDetails,
  getSubscriptionDetailsClear,
  getSubscriptionPlan,
  getSubscriptionPlanClear,
} from "../../../../redux/subscription/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import Slider from "react-slick";
import _ from "lodash";
import PrevArrow from "../../../LearningPaths/PrevArrow";
import NextArrow from "../../../LearningPaths/NextArrow";
import useLogin from "../../../../custom-hooks/useLogin";
import { SessionKeys, subscriptionTrailType } from "../../../../utils/AppUtils";
import ConfirmModal from "../../../modal/ConfirmModal";
import {
  changeSubscriptionPlanClear,
  fetchSubscribedData,
} from "../../../../redux/checkout/actions";
import { getSmartBar } from "../../../../redux/home/actions";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import NewSubscriptionPriceCardComponent from "../NewSubscriptionPriceCard/NewSubscriptionPriceCardComponent";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Page from "../../../Page";
import Loader from "../../../Loader/Loader";

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const SubscriptionPriceSectionUpdatedComp = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const subscriptionPlan = useSelector(
    (state) => state.subscription.subscriptionPlan
  );
  const changeSubscriptionData = useSelector(
    (state) => state.checkout.changeSubscriptionPlan
  );

  const subscriptionDetails = useSelector(
    (state) => state.subscription.getSubscriptionDetails
  );

  const authBroker = useSelector((state) => state.auth.authBroker);

  const [apiList, setAPIList] = useState([]);
  // const [priceCardList, setPriceCardList] = useState([
  //     { isLoading: true }, { isLoading: true }, { isLoading: true },
  // ])
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");
  const [isConfirm, setIsConfirm] = useState(true);
  const { isLoggedIn, subscribedData } = useLogin();
  const [isFetching, setIsFetching] = useState(true);

  const [key, setKey] = useState("starter");
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionDetailData, setSubscriptionDetailData] = useState({});

  useEffect(() => {
    if (tab === "1") {
      setKey("starter");
    } else if (tab === "2") {
      setKey("pro");
    } else if (tab === "3") {
      setKey("premium");
    }
  }, [tab]);

  useEffect(() => {
    getSubscriptionDetailsAPI();
    return () => {
      dispatch(getSubscriptionDetailsClear());
    };
  }, []);

  const getSubscriptionDetailsAPI = () => {
    setIsLoading(true);
    let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    dispatch(
      getSubscriptionDetails({
        module: "subscription-details",
        postData: {},
      })
    );
   };

  useEffect(() => {
    if (!_.isEmpty(subscriptionDetails)) {
      if (subscriptionDetails?.status === "success") {
        console.log("checj--", subscriptionDetails);
        setSubscriptionDetailData(subscriptionDetails?.payload?.payload);
        setIsLoading(false);
      } else {
        setSubscriptionDetailData({});
        setIsLoading(false);
      }
    }
    return () => {};
  }, [subscriptionDetails]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   if (props.fetchData) fetchSubscription();

  //   getSmartBarData();
  // }, [dispatch, props.fetchData]);

  // useEffect(() => {
  //   if (!_.isEmpty(subscriptionPlan)) {
  //     setIsFetching(false);
  //   }
  // }, [subscriptionPlan]);

  // const priceCardList = useMemo(() => {
  //   console.log("SUBSCRIPTION", subscriptionPlan);
  //   if (!_.isEmpty(subscriptionPlan)) {
  //     if (subscriptionPlan.status === "success") {
  //       let planList = subscriptionPlan.payload.data;
  //       if (!_.isEmpty(planList)) {
  //         let subscriptionList = [];
  //         planList = _.sortBy(planList, "weightage");
  //         let isCurrentlySubscribed = false;
  //         let subscribedPlanName = "";
  //         let subscribedBillingType = "";
  //         for (let [index, plan] of planList.entries()) {
  //           if (isCurrentlySubscribed && !subscribedPlanName) {
  //             isCurrentlySubscribed = false;
  //           }
  //           let planTitle = `Xsel Subscription ${plan.title} Plan`;
  //           let cardPrice = "Free";
  //           let cardPunchLine = "Zero cost forever";
  //           let btnName = "Sign up to access";
  //           let isPaid = false;
  //           let isUpgradePlan = false;
  //           let isDowngradePlan = false;

  //           // if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
  //           //   cardPrice = `$${plan.billed_yearly_price_per_mnth}/month`;
  //           // } else
  //           if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
  //             cardPrice = plan.billed_monthly_price_per_mnth;
  //             if (cardPrice.includes(".")) {
  //               cardPrice = `${cardPrice.split(".")[0]}<sup>${
  //                 cardPrice.split(".")[1]
  //               }</sup>`;
  //             }
  //             cardPrice = `$${cardPrice}`;
  //           }

  //           // if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
  //           //   cardPunchLine = "Billed anually";
  //           // } else if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
  //           //   cardPunchLine = "Billed monthly";
  //           // }

  //           if (
  //             _.toNumber(plan.billed_yearly_price_per_mnth) > 0 &&
  //             _.toNumber(plan.billed_monthly_price_per_mnth) > 0
  //           ) {
  //             cardPunchLine = "";
  //           }

  //           if (
  //             _.toNumber(plan.billed_monthly_price_per_mnth) > 0 ||
  //             _.toNumber(plan.billed_yearly_price_per_mnth) > 0
  //           ) {
  //             btnName = "Get started";
  //             isPaid = true;
  //           }

  //           // if (!isPaid && isLoggedIn) {
  //           //     btnName = "Change to this plan"
  //           // }

  //           if (
  //             _.toNumber(plan.billed_monthly_price_per_mnth) > 0 &&
  //             _.toNumber(plan.billed_yearly_price_per_mnth) > 0
  //           ) {
  //             planTitle = planTitle + " - Renews monthly or yearly";
  //           } else if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
  //             planTitle = planTitle + " - Renews monthly";
  //           } else if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
  //             planTitle = planTitle + " - Renews yearly";
  //           }

  //           if (isLoggedIn) {
  //             if (
  //               !_.isEmpty(subscribedData) &&
  //               subscribedData.subscription_active
  //             ) {
  //               if (subscribedData.ecom_sub_id === plan.id) {
  //                 isCurrentlySubscribed = true;
  //                 btnName = "You are currently on on this plan.";
  //                 subscribedPlanName = plan.title;
  //                 subscribedBillingType = subscribedData.billing_type;
  //                 // if (subscribedData.billing_type === "monthly") {
  //                 //   plan.billed_monthly_price_per_mnth = 0;
  //                 // } else if (subscribedData.billing_type === "annually") {
  //                 //   plan.billed_yearly_price_per_mnth = 0;
  //                 // }
  //                 for (let i of [...Array(index).keys()]) {
  //                   let lastSubData = subscriptionList[i];
  //                   console.log("last sub data", lastSubData);
  //                   // lastSubData.isCurrentlySubscribed = true;
  //                   lastSubData.btnName = `Included in ${plan.title}`;
  //                   lastSubData.subscribedPlanName = plan.title;
  //                   lastSubData.isDowngradePlan = true;
  //                   // lastSubData.isUpgradePlan = true
  //                 }
  //               } else if (isCurrentlySubscribed) {
  //                 isUpgradePlan = true;
  //                 if (_.toNumber(plan.trial_period_in_days)) {
  //                   let entityName = subscriptionTrailType(
  //                     _.toNumber(plan.trial_period_in_days)
  //                   );
  //                   btnName = `Try it FREE for a ${entityName}`;
  //                 }
  //               }
  //             } else if (!isPaid && plan.weightage === 0) {
  //               btnName = "You are currently on this plan.";
  //               isCurrentlySubscribed = true;
  //             } else if (_.toNumber(plan.trial_period_in_days)) {
  //               let entityName = subscriptionTrailType(
  //                 _.toNumber(plan.trial_period_in_days)
  //               );
  //               btnName = `Try it FREE for a ${entityName}`;
  //               isCurrentlySubscribed = false;
  //             }
  //           }
  //           // alert(JSON.stringify(plan))

  //           subscriptionList.push({
  //             cardId: plan.id,
  //             cardTitle: plan.title,
  //             sessionCount: index === 2 ? "All" : plan.free_session_per_month,
  //             roleplayCount: plan.free_roleplays_count,
  //             rewardPoint: plan.reward_point,
  //             trialPeriodInDays: plan.trial_period_days,
  //             foundationCourses: plan.foundation_courses,
  //             videoAccess: plan.video_access,
  //             mobileAppAccess: _.toNumber(plan.mobile_app_access),
  //             exclusiveOffers: _.toNumber(plan.exclusive_offers),
  //             technicalSupport: _.toNumber(plan.technical_support),
  //             niitCoursesDiscount: _.toNumber(plan.niit_courses_discount),
  //             narCertificationDiscount: _.toNumber(
  //               plan.nar_certification_discount
  //             ),
  //             partnerCoursesDiscount: _.toNumber(plan.partner_courses_discount),
  //             coachingServiceDiscount: _.toNumber(
  //               plan.coaching_service_discount
  //             ),
  //             aiCourseDiscount: _.toNumber(plan.ai_course_discount),
  //             providerLogo: !_.isEmpty(plan.provider)
  //               ? plan.provider.provider_img
  //                 ? plan.provider.provider_img
  //                 : ""
  //               : "",
  //             isLoading: false,
  //             cardPriceInfo: {
  //               monthly: _.toNumber(plan.billed_monthly_price_per_mnth),
  //               yearly: _.toNumber(plan.billed_yearly_price_per_mnth),
  //               isAddToCart: true,
  //             },
  //             cardThumbnail: plan.subscription_img,
  //             cardPlanTitle: planTitle,
  //             cardLogo: plan.subscription_logo_path,
  //             isCurrentlySubscribed: isUpgradePlan
  //               ? false
  //               : isCurrentlySubscribed,
  //             isUpgradePlan,
  //             isDowngradePlan,
  //             isLoggedIn,
  //             isPaid,
  //             cardPrice,
  //             cardPunchLine,
  //             btnName,
  //             subscribedPlanName,
  //             subscribedBillingType,
  //           });
  //         }
  //         console.log("SUBSCRIPTIONLIST", subscriptionList);
  //         return subscriptionList;
  //       }
  //     }
  //   }
  //   if (isFetching) {
  //     return [{ isLoading: false }, { isLoading: false }, { isLoading: false }];
  //   }
  //   return [];
  // }, [subscriptionPlan, subscribedData]);

  // useEffect(() => {
  //   if (!_.isEmpty(changeSubscriptionData)) {
  //     console.log("CHANGE SUB PLAN DATA", changeSubscriptionData);
  //     setIsConfirm(false);
  //     if (changeSubscriptionData.status === "success") {
  //       setIsConfirm(false);
  //       dispatch(
  //         fetchSubscribedData({
  //           method: "POST",
  //           URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_DATA}`,
  //           payload: {
  //             token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //           },
  //           isJSON: true,
  //         })
  //       );
  //       setConfirmMsg("Successfully subscribed to new plan.");
  //       setConfirmModal(true);
  //       props.setMainPageLoading(false);
  //     } else {
  //       setIsConfirm(false);
  //       setConfirmMsg("Unable to subscribed to new plan.");
  //       setConfirmModal(true);
  //       props.setMainPageLoading(false);
  //     }
  //     dispatch(changeSubscriptionPlanClear());
  //   }
  // }, [changeSubscriptionData]);

  // const fetchSubscription = () => {
  //   let token = "";
  //   if (isLoggedIn || localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
  //     token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
  //   }
  //   dispatch(
  //     getSubscriptionPlan({
  //       URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PLAN}`,
  //       payload: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //       },
  //       isJSON: true,
  //       method: "post",
  //     })
  //   );
  // };

  const getSmartBarData = () => {
    let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    dispatch(
      getSmartBar({
        module: "getSmartBar",
        postData: {
          token: token ? token : "",
        },
      })
    );
  };

  const newlyAddedVideos = () => {
    return (
      <>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Follow UP During Holiday Season for 2025 Leads
          </td>
          <td className="otemrole">Mary-Anne Gillespie - Red Apple Coaching</td>
          <td className="officename">Video</td>
        </tr>

        <tr className="addBGcustomw">
          <td className="itmeeeamil">Holiday Objections Role Play</td>
          <td className="otemrole">Mary-Anne Gillespie - Red Apple Coaching</td>
          <td className="officename">Video</td>
        </tr>

        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            A Year of Progress: Recapping REMARKETER’s 2024 Additions
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>

        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Smarter Real Estate Finances: Your Guide to Year-End Prep
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Redefine Door Knocking Efficiency with REMARKETER’s Updated Module
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            REMARKETER Search Mastery: Find Properties Like a Pro
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            From Sneak Peeks to Sales: Market “Coming Soon” Listings with
            REMARKETER
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Turn Open Houses into High-Converting Events with REMARKETER
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Build the Buzz: Pre-Construction Marketing with Impactful Landing
            Pages
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Stand Out in the Inbox: Create Powerful Newsletters with REMARKETER
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>

        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Modernize Your Real Estate Website: Effective Customization and
            Landing Page Strategies
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Equip Your Buyers with Instant Data: Master REMARKETER’s Instant CMA
            Tool
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Optimize Real Estate Emails for Better Client Engagement
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Introducing REMARKETER's New Feature – Automate Listings with Zapier
            for Instagram and Facebook
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            AI-Powered Email, Blogging, and Market Analysis: The Future of Real
            Estate Marketing
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Analyze and Predict Trends with REMARKETER’s Built-In Statistical
            Data
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">
            Kickstart the New Year with CRM and Marketing Excellence!
          </td>
          <td className="otemrole">REMARKETER</td>
          <td className="officename">Video</td>
        </tr>
      </>
    );
  };

  const renderStarterTable = () => {
    return (
      <div className="row my-team-table">
        <div className="col-lg-12 col-md-12">
          <div className="course-info-table">
            <table className="table mb-0 office_list table-striped">
              <thead>
                <tr>
                  <th>LEARNING CONTENT</th>
                  <th>PARTNER</th>
                  <th>TYPE</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionDetailData?.subscription_data?.Starter?.map(
                  (item) => {
                    return (
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">{item?.content_name}</td>
                        <td className="otemrole">{item?.provider}</td>
                        <td className="officename">{item?.type}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
              {/* <tbody>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Health and Safety in Real Estate
                  </td>
                  <td className="otemrole">Xsel</td>
                  <td className="officename">Course</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Communication and Real Estate Professionalism
                  </td>
                  <td className="otemrole">Xsel</td>
                  <td className="officename">Course</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">Cold Calling</td>
                  <td className="otemrole">Xsel</td>
                  <td className="officename">Course</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Building your Business with Proper Systems
                  </td>
                  <td className="otemrole">Xsel</td>
                  <td className="officename">Course</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">Agency</td>
                  <td className="otemrole">Xsel</td>
                  <td className="officename">Course</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">Characteristics of Success</td>
                  <td className="otemrole">Leader's Edge Training</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">For Sale Signs</td>
                  <td className="otemrole">Leader's Edge Training</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    How Important Is It to Have a Goal?
                  </td>
                  <td className="otemrole">Leader's Edge Training</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">I Want to Build a Team</td>
                  <td className="otemrole">Leader's Edge Training</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">Presentation for Friends</td>
                  <td className="otemrole">Leader's Edge Training</td>
                  <td className="officename">Video</td>
                </tr>

                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Follow UP During Holiday Season for 2025 Leads
                  </td>
                  <td className="otemrole">
                    Mary-Anne Gillespie - Red Apple Coaching
                  </td>
                  <td className="officename">Video</td>
                </tr>

                <tr className="addBGcustomw">
                  <td className="itmeeeamil">Holiday Objections Role Play</td>
                  <td className="otemrole">
                    Mary-Anne Gillespie - Red Apple Coaching
                  </td>
                  <td className="officename">Video</td>
                </tr>

                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    A Year of Progress: Recapping REMARKETER’s 2024 Additions
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>

                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Smarter Real Estate Finances: Your Guide to Year-End Prep
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Redefine Door Knocking Efficiency with REMARKETER’s Updated
                    Module
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    REMARKETER Search Mastery: Find Properties Like a Pro
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    From Sneak Peeks to Sales: Market “Coming Soon” Listings
                    with REMARKETER
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Turn Open Houses into High-Converting Events with REMARKETER
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Build the Buzz: Pre-Construction Marketing with Impactful
                    Landing Pages
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Stand Out in the Inbox: Create Powerful Newsletters with
                    REMARKETER
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>

                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Modernize Your Real Estate Website: Effective Customization
                    and Landing Page Strategies
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Equip Your Buyers with Instant Data: Master REMARKETER’s
                    Instant CMA Tool
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Optimize Real Estate Emails for Better Client Engagement
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Introducing REMARKETER's New Feature – Automate Listings
                    with Zapier for Instagram and Facebook
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    AI-Powered Email, Blogging, and Market Analysis: The Future
                    of Real Estate Marketing
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Analyze and Predict Trends with REMARKETER’s Built-In
                    Statistical Data
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>
                <tr className="addBGcustomw">
                  <td className="itmeeeamil">
                    Kickstart the New Year with CRM and Marketing Excellence!
                  </td>
                  <td className="otemrole">REMARKETER</td>
                  <td className="officename">Video</td>
                </tr>

                {false && (
                  <>
                    <tr className="addBGcustomw">
                      <td className="itmeeeamil">
                        Periodic free webinar for the agents
                      </td>
                      <td className="otemrole">Dan Wood, Co Creative Inc.</td>
                      <td className="officename">Webinar</td>
                    </tr>
                    <tr className="addBGcustomw">
                      <td className="itmeeeamil">
                        Periodic free webinar for the agents
                      </td>
                      <td className="otemrole">
                        Ron O'Neil - AI Intelligent Solutions
                      </td>
                      <td className="officename">Webinar</td>
                    </tr>
                    <tr className="addBGcustomw">
                      <td className="itmeeeamil">Periodic free newsletter</td>
                      <td className="otemrole">
                        Ron O'Neil - AI Intelligent Solutions
                      </td>
                      <td className="officename">Newsletter</td>
                    </tr>
                    <tr className="addBGcustomw">
                      <td className="itmeeeamil">
                        Periodic free webinar for the agents
                      </td>
                      <td className="otemrole">
                        Sean Provencha - End Game Coaching
                      </td>
                      <td className="officename">Webinar</td>
                    </tr>
                  </>
                )}
              </tbody> */}
            </table>
          </div>
        </div>
      </div>
    );
  };

  const extendedNewlyAddedVideos = () => {
    return (
      <>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">I Want a Better Split</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">I'm Too Busy for a Personal Life</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">Is It Important to Have a Niche?</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">Knowing Your Inventory</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">Meet Buyers at Office</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">My Buyers Can't Decide</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">My Clients Only Want to Text</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
        <tr className="addBGcustomw">
          <td className="itmeeeamil">Not Tech Savvy</td>
          <td className="otemrole">Leader's Edge Training</td>
          <td className="officename">Video</td>
        </tr>
      </>
    );
  };

  const renderProTable = () => {
    return (
      <div className="row my-team-table">
        <div className="col-lg-12 col-md-12">
          <div className="course-info-table">
            <table className="table mb-0 office_list table-striped">
              <thead>
                <tr>
                  <th>LEARNING CONTENT</th>
                  <th>PARTNER</th>
                  <th>TYPE</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionDetailData?.subscription_data?.Pro?.map((item) => {
                  return (
                    <tr className="addBGcustomw">
                      <td className="itmeeeamil">{item?.content_name}</td>
                      <td className="otemrole">{item?.provider}</td>
                      <td className="officename">{item?.type}</td>
                    </tr>
                  );
                })}
              </tbody>
              {false && (
                <tbody>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Health and Safety in Real Estate
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Communication and Real Estate Professionalism
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Cold Calling</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Building your Business with Proper Systems
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Agency</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Deposits</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Workplace Sensitivity</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Canada’s Anti-Spam Legislation (CASL)
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">FINTRAC</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Marketing With Purpose</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Overcoming Objections</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Door Knocking</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Characteristics of Success</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">For Sale Signs</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Important Is It to Have a Goal?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">I Want to Build a Team</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Presentation for Friends</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Advertising and Privacy</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Convincing Buyers to Buy</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Do Open Houses Work?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Much Commission Should I Charge?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Is Using Profanity Appropriate?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Motivate Yourself to Prospect
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Referral Partners Are Great for Business
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Should Buyers Ride in My Car?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Thinking about Starting a Team?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Will Technology Make Us Obsolete?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>

                  {newlyAddedVideos()}

                  {false && (
                    <>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">Dan Wood, Co Creative Inc.</td>
                        <td className="officename">Webinar</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">
                          Ron O'Neil - AI Intelligent Solutions
                        </td>
                        <td className="officename">Webinar</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">Periodic free newsletter</td>
                        <td className="otemrole">
                          Ron O'Neil - AI Intelligent Solutions
                        </td>
                        <td className="officename">Newsletter</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">
                          Sean Provencha - End Game Coaching
                        </td>
                        <td className="officename">Webinar</td>
                      </tr>
                    </>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  };

  const renderPremiumTable = () => {
    return (
      <div className="row my-team-table">
        <div className="col-lg-12 col-md-12">
          <div className="course-info-table">
            <table className="table mb-0 office_list table-striped">
              <thead>
                <tr>
                  <th>LEARNING CONTENT</th>
                  <th>PARTNER</th>
                  <th>TYPE</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionDetailData?.subscription_data?.Premium?.map(
                  (item) => {
                    return (
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">{item?.content_name}</td>
                        <td className="otemrole">{item?.provider}</td>
                        <td className="officename">{item?.type}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
              {false && (
                <tbody>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Health and Safety in Real Estate
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Communication and Real Estate Professionalism
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Cold Calling</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Building your Business with Proper Systems
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Agency</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Deposits</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Workplace Sensitivity</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Canada’s Anti-Spam Legislation (CASL)
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">FINTRAC</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Marketing With Purpose</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Listing Presentation</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Privacy Act and PIPEDA</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Overcoming Objections</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Branding in the Real Estate World
                    </td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Buyer Presentation</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Door Knocking</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Mutual Release</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Mandatory Document Workflow</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Buyer Offer – Forms</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Buyer Offer – Clauses</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Seller Listing – Forms</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Seller Offer – Clauses</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Course</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Overcoming Objections</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Door Knocking</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">New to the Business</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Calling Potential Leads</td>
                    <td className="otemrole">Xsel</td>
                    <td className="officename">Role play</td>
                  </tr>

                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Characteristics of Success</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">For Sale Signs</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Important Is It to Have a Goal?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">I Want to Build a Team</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Presentation for Friends</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Advertising and Privacy</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Convincing Buyers to Buy</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Do Open Houses Work?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Much Commission Should I Charge?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Is Using Profanity Appropriate?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Motivate Yourself to Prospect
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Referral Partners Are Great for Business
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Should Buyers Ride in My Car?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Thinking about Starting a Team?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Will Technology Make Us Obsolete?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>

                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Agent Success App</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Appointment with Expired</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Best Way to Get a Price Reduction
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Buy First Then Sell</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Competing with Discount Agents
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Convert a FSBO</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Digital or Paper Listing Presentation
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Do Prospecting Calls Work?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Don't Lose Out in Multiple Offers
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Does Print Marketing Work?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Get Buyers Pre-Approved</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Getting Buyers to Commit</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Do I Improve My Door Knocking?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Do I Make $200,000 a Year?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Long Should a Listing Presentation Take?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How Many Just Listed or Sold Cards Should I Send?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How to Communicate with Out of Town Buyers?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  {extendedNewlyAddedVideos()}
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Point Out Repairs</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Renovate Before You List</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Seller Wants Too Much for Their House
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Seller Won't Pay Buyer Commission
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Sellers Wants to Interview Others
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Should I Call to Confirm?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Should I Join a Team?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Should I Send a Pre-Listing Package?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Should I Take an Overpriced Listing?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Should I Work from the Office?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">What If It Sells Quickly?</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      What Should I Take on a Listing Appointment?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Will You Cut Your Commission?
                    </td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Working Part-Time</td>
                    <td className="otemrole">Leader's Edge Training</td>
                    <td className="officename">Video</td>
                  </tr>

                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      What Is Staging and Why Is It Important?
                    </td>
                    <td className="otemrole">A Lady's Touch Inc.</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      How to Choose the Right Staging Company?
                    </td>
                    <td className="otemrole">A Lady's Touch Inc.</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">How to Stage on a Budget?</td>
                    <td className="otemrole">A Lady's Touch Inc.</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">Who pays for Staging?</td>
                    <td className="otemrole">A Lady's Touch Inc.</td>
                    <td className="officename">Video</td>
                  </tr>
                  <tr className="addBGcustomw">
                    <td className="itmeeeamil">
                      Ultimate Listing Presentation
                    </td>
                    <td className="otemrole">Tom Storey</td>
                    <td className="officename">Course</td>
                  </tr>

                  {newlyAddedVideos()}

                  {false && (
                    <>
                      {" "}
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">Dan Wood, Co Creative Inc.</td>
                        <td className="officename">Webinar</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">
                          Ron O'Neil - AI Intelligent Solutions
                        </td>
                        <td className="officename">Webinar</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">Periodic free newsletter</td>
                        <td className="otemrole">
                          Ron O'Neil - AI Intelligent Solutions
                        </td>
                        <td className="officename">Newsletter</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td className="itmeeeamil">
                          Periodic free webinar for the agents
                        </td>
                        <td className="otemrole">
                          Sean Provencha - End Game Coaching
                        </td>
                        <td className="officename">Webinar</td>
                      </tr>
                    </>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <>
        <div className="prcieongnew1">
          <div className="mt-4">
            <div className="">
              {tab === "1" || key === "starter"
                ? subscriptionDetailData?.stater_note
                : tab === "2" || key === "pro"
                ? subscriptionDetailData?.pro_note
                : subscriptionDetailData?.premium_note}
            </div>
          </div>
          {tab === "1" || key === "starter"
            ? renderStarterTable()
            : tab === "2" || key === "pro"
            ? renderProTable()
            : renderPremiumTable()}
          {false && (
            <div class="pricing-table">
              <div class="features-column">
                <h3>Features</h3>
                <ul>
                  <li>Foundational Courses</li>
                  <li>Video Library Access</li>
                  <li>Monthly Live Expert Webinar</li>
                  {false && <li>Mobile App</li>}
                  <li>Exclusive Offers on Select Purchases</li>
                  <li>Reward Points</li>
                  <li>Access to Interactive Roleplays</li>
                  <li>Technical Support</li>
                  <li>Discounts on NIIT Courses</li>
                  <li>NAR Certification Course Discounts</li>
                  <li>Expert Partner Course Discounts</li>
                  <li>Coaching Services Discount</li>
                  <li>AI Course Discount</li>
                </ul>
              </div>
              <div className="plan-wrpaer d-flex gap-3">
                {/* {priceCardList.map((p, i) => {
                  return (
                    <NewSubscriptionPriceCardComponent
                      {...p}
                      setMainPageLoading={props.setMainPageLoading}
                      key={`price-card-${i + 1}`}
                    />
                  );
                })} */}
              </div>
            </div>
          )}
          {authBroker.payload?.user?.is_corporate && false && (
            <div class="note">
              *Starter subscription worth $9.99 monthly complimentary for C21
              agents for a limited time.
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <section className="subscription-pricing pt-5 pb-5">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-12">
                <button className="mb-3 bck-btn" onClick={() => navigate(-1)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="17"
                    viewBox="0 0 10 17"
                    fill="none"
                  >
                    <path
                      d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                      fill="black"
                    />
                  </svg>{" "}
                  Back
                </button>
              </div>
              <div className="col-md-8 col-12 mt-4">
                <div className="subscriptions-row">
                  <span className="subscription-title">Xsel Subscriptions</span>
                  <h2 className="">Simple, transparent pricing</h2>
                  <span className="subscriptions-subhead">
                    Xsel is accessible to everyone. Different folks, different
                    needs.
                  </span>
                </div>
              </div>

              <div className="col-md-4 col-12"></div>
            </div>
            <div className="col-md-12">
              <div className="contsection mt-4">
                <nav>
                  <div className="nav-section-box" id="nav-tab" role="tablist">
                    <Tabs
                      underline
                      activeKey={key}
                      onSelect={(k) => {
                        if (k === "starter") {
                          navigate("/subscription-updated?tab=1", {
                            replace: true,
                          });
                        } else if (k === "pro") {
                          navigate("/subscription-updated?tab=2", {
                            replace: true,
                          });
                        } else if (k === "premium") {
                          navigate("/subscription-updated?tab=3", {
                            replace: true,
                          });
                        }
                        if (document.getElementById("idFooter") !== null) {
                          document.getElementById("idFooter").style.display =
                            "none";
                        }
                        setTimeout(() => {
                          setKey(k);
                          if (document.getElementById("idFooter") !== null) {
                            document.getElementById("idFooter").style.display =
                              "block";
                          }
                        }, 200);
                      }}
                    >
                      <Tab eventKey={"starter"} title="Starter">
                        {renderContent()}
                      </Tab>
                      <Tab eventKey={"pro"} title="Pro">
                        {key === "pro" && renderContent()}
                      </Tab>

                      <Tab eventKey={"premium"} title="Premium">
                        {key === "premium" && renderContent()}
                      </Tab>
                    </Tabs>
                    {/* {renderContent()} */}
                  </div>
                </nav>
              </div>
            </div>

            <ConfirmModal
              confirmModal={confirmModal}
              setConfirmModal={setConfirmModal}
              showModalMsg={confirmMsg}
              isConfirm={isConfirm}
              confirmId=""
              confirmAction={() => {
                setConfirmModal(false);
              }}
            />
          </div>
        </section>
      </Page>
    </>
  );
};

export default SubscriptionPriceSectionUpdatedComp;
